export default "__VITE_ASSET__DLE9bniP__"